import React, { useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap5';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import { useContext as useUsersContext } from 'components/Users/Context';
import actions from 'components/Affiliates/Training/Actions';

import Modal from './Modal';

export default function Index() {
  const { state: stateUsers } = useUsersContext();
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const affiliate = stateUsers.user.attributes.specific;

  const requestTraining = () => {
    setLoading(true);

    actions.requestTraining(
      affiliate.id,
      () => {
        setShowModal(true);
        setLoading(false);
      },
    );
  };

  return (
    <div className="content">
      <Row>
        <Col lg={{ span: 6, order: 'last' }}>
          <div className="bg-photo bg-affiliates-training-photo" />
        </Col>

        <Col lg={{ span: 6, order: 'first' }}>
          <div className="py-4 px-sm-4 p-xxl-5">
            <h1 className="mb-5">Certification Training</h1>

            <p>
              Welcome to the LeggUP Talent Insurance Consultant Certification Training!
              Dive into the exclusive resources tailored for our consultants;
              click &ldquo;Request Access to Training&rdquo; to begin your journey.
            </p>

            <Button
              className="mt-4"
              onClick={requestTraining}
              disabled={loading}
            >
              {loading && <LoadingPlaceholder placement="inline" text=" " />}
              Request Access to Training
            </Button>
          </div>
        </Col>
      </Row>

      <Modal
        show={showModal}
        onClose={() => setShowModal(false)}
      />
    </div>
  );
}
